import React, {Component} from 'react';
import axios from 'axios';
import {showFatalOverlay} from '../../asset/js/authGuard';
const withUserData = () => (WrappedComponent) => {
    return class extends Component {
        state = {
            userInfo: null,
            //rootURL:'http://api.itconline.co.kr/'
        };

        _initialize() {

            ////console.log(this.props.tempStepInfo);
            ////console.log("this.props.apiUrl:",this.props.apiUrl);
            if (this.props.serverData.auth_type === "N") {
                Promise.all([
                    //axios.get(`${this.props.apiUrl}/users/${this.props.tempStepInfo.step}/${this.props.tempStepInfo.std_lesson}`.replace(/\s/g, '')),  //Contents
                    //axios.get(`${this.props.apiUrl}/users/${this.props.serverData.mem_idx}/${this.props.serverData.class_idx}`)
                    axios({
                        method: 'get',
                        url: `${this.props.apiUrl}/users/${this.props.serverData.mem_idx}/${this.props.serverData.class_idx}`.replace(/\s/g, ''),
                    })
                ])
                .then(([resUserInfo]) => {
                    const userInfo = resUserInfo.data;
                    //console.log("API에서 받아온 유저 정보:", userInfo);
                    this.setState({
                        ...this.state,
                        userInfo,
                    });
                })
                .catch((err) => {
                    //유저 정보를 못 받으면 Intro가 무한 로딩으로 굳으므로 안내 화면으로 대체한다.
                    //401은 전역 authGuard가 안내하므로 그 외의 실패만 처리.
                    const status = err.response && err.response.status;
                    if (status !== 401) {
                        showFatalOverlay('학습 정보를 불러오지 못했습니다',
                            '이 창을 닫고, 홈페이지에서 다시 로그인한 뒤<br>[학습하기] 버튼으로 입장해 주세요.');
                    }
                })
                .then(function () {

                });
            } else if (this.props.serverData.auth_type === "F") {

                let userInfo = {
                    std_lesson: 1,
                    lesson_no: 1,
                    skin_alphabet: 'a',
                    score_type: 1, //scoreType === 0 이면 text, 1이면 abc
                    class_type:'B',
                    student_gb:'N', //"S" 면 스피드 학습 안되게, "N"일때는 스피드 학습 가능
                };

                this.setState({
                    ...this.state,
                    userInfo,
                });
            } else if (this.props.serverData.auth_type === "A"){

                let userInfo = {
                    std_lesson: 1,
                    lesson_no: 1,
                    skin_alphabet: 'a',
                    score_type: 1, //scoreType === 0 이면 text, 1이면 abc
                    class_type:'B',
                    student_gb:'N', //"S" 면 스피드 학습 안되게, "N"일때는 스피드 학습 가능
                };

                this.setState({
                    ...this.state,
                    userInfo,
                });
            } else {
                let userInfo = {
                    std_lesson: 1,
                    lesson_no: 1,
                    skin_alphabet: 'a',
                    score_type: 1, //scoreType === 0 이면 text, 1이면 abc
                    class_type:'B',
                    student_gb:'N', //"S" 면 스피드 학습 안되게, "N"일때는 스피드 학습 가능
                };

                this.setState({
                    ...this.state,
                    userInfo,
                });
            }


        };

        componentDidMount() {
            this._initialize();
        }

        render() {
            const {userInfo} = this.state;
            return (
                <WrappedComponent {...this.props}
                                  userInfo={userInfo}
                    //userInfo={this.state.tempUserInfo}
                />
            )
        }
    }

};

export default withUserData;